import { DocumentType } from '@zorro/clients';
import { Tabs } from '@zorro/design-system/v2/Tabs';
import { DeepReadonly } from '@zorro/types';
import { Space } from '@zorro/web/design-system';
import { ReactElement } from 'react';

const allDocumentsTabs = [
  DocumentType.ADMIN,
  DocumentType.PLAN,
  DocumentType.INVOICE,
];
const documentTabConfig: DeepReadonly<{
  [tabType in DocumentType]: {
    label: string;
    isDisabled: boolean;
  };
}> = {
  [DocumentType.ADMIN]: {
    label: 'Admin',
    isDisabled: false,
  },
  [DocumentType.PLAN]: {
    label: 'Plan',
    isDisabled: false,
  },
  [DocumentType.INVOICE]: {
    label: 'Invoices',
    isDisabled: false,
  },
  [DocumentType.ZORRO_PAY]: {
    label: 'Zorro Pay',
    isDisabled: true,
  },
  [DocumentType.COMPLIANCE]: {
    label: 'Invoices',
    isDisabled: true,
  },
};

type Props = {
  onSelectTab: (documentType: DocumentType) => void;
  selectedTab: DocumentType;
  children: ReactElement;
};

export const DocumentTabWrapper = ({
  onSelectTab,
  selectedTab,
  children,
}: Props) => {
  return (
    <>
      <Tabs maw="410px" mt="sm" keepMounted={false} value={selectedTab}>
        <Tabs.List grow>
          {allDocumentsTabs
            .filter(
              (documentType) => !documentTabConfig[documentType].isDisabled
            )
            .map((documentTab) => {
              const { label, isDisabled } = documentTabConfig[documentTab];

              return (
                <Tabs.Tab
                  onClick={() => {
                    onSelectTab(documentTab);
                  }}
                  disabled={isDisabled}
                  value={documentTab}
                  key={documentTab}
                >
                  {label}
                </Tabs.Tab>
              );
            })}
        </Tabs.List>
      </Tabs>
      <Space h="2rem" />
      {children}
    </>
  );
};
